import Vue from 'vue';
import { gsap } from 'gsap';
import countryData from '../data/countryData';

Vue.component('dropdown-component', {
    props: {
        dialCode: {
            type: Boolean,
            default: false,
        },

        data: {
            type: Array,
            default: () => [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            selectedDropdownValue: '',
            dropdownData: [],
            hasError: null,
            dropdownIsOpen: false,
            defaultValue: null,
        };
    },

    computed: {
        filteredData() {
            if (!this.selectedDropdownValue || this.selectedDropdownValue === '') {
                return this.dropdownData;
            }

            const filter = this.dropdownData.filter((item) => {
                const keys = Object.keys(item);
                for (let i = 0; i < keys.length; i++) {
                    const key = item[keys[i]].toLowerCase();
                    const searchValue = this.selectedDropdownValue.toLowerCase();
                    if (key.includes(searchValue)) {
                        return item;
                    }
                }
                return false;
            });

            return filter;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.dropdownList = this.$el.querySelector('.dropdown__list-holder');
        this.dropdownArrow = this.$el.querySelector('.dropdown-select-arrow');

        this.dropdownData = this.data;

        if (this.dialCode) {
            this.dropdownData = countryData.sort((a, b) => a.code.localeCompare(b.code));

            for (let i = 0; i < this.dropdownData.length; i++) {
                if (this.dropdownData[i].code === 'NL') {
                    this.defaultValue = this.dropdownData[i];
                    this.selectedDropdownValue = this.dropdownData[i].dial_code;
                    this.$emit('change', this.selectedDropdownValue);
                    return;
                }
            }
        }

        if (!this.dialCode) {
            this.defaultValue = this.dropdownData[0];
            this.selectedDropdownValue = this.dropdownData[0].value;
            this.$emit('change', this.selectedDropdownValue);
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleDropdown(state = null) {
            if (typeof state !== 'boolean') {
                this.dropdownIsOpen = !this.dropdownIsOpen;
            } else {
                this.dropdownIsOpen = state;
            }

            const tl = gsap.timeline();

            tl
                .to(this.dropdownList, {
                    duration: 1,
                    height: this.dropdownIsOpen ? 'auto' : 0,
                    ease: 'power4.out',
                })
                .to(this.dropdownArrow, {
                    duration: 0.7,
                    rotate: this.dropdownIsOpen ? 180 : 0,
                    ease: 'power4.out',
                }, '<');
        },

        selectDropdownItem(e, selectedValue = null) {
            if (selectedValue) {
                this.selectedDropdownValue = selectedValue;
                this.$emit('change', selectedValue);
                return;
            }

            const { value } = e.target.dataset;
            this.$emit('change', value);
            this.selectedDropdownValue = value;
        },

        fallBack(e) {
            if (!e || !e.target || !e.target.value || e.target.value === '') {
                this.$emit('change', this.defaultValue.dial_code);
                this.selectedDropdownValue = this.defaultValue.dial_code;
            }

            e.target.blur();

            const { value } = e.target;

            const lowerCased = value.toLowerCase();

            // Select first value that includes the search term
            const selectedValue = this.dropdownData.filter((item) => {
                const keys = Object.keys(item);
                for (let i = 0; i < keys.length; i++) {
                    const key = item[keys[i]].toLowerCase();
                    if (key.includes(lowerCased)) {
                        return item;
                    }
                }

                return false;
            });

            if (!selectedValue) {
                this.$emit('change', this.defaultValue.dial_code);
                this.selectedDropdownValue = this.defaultValue.dial_code;
                return;
            }

            this.$emit('change', selectedValue[0].dial_code);
            this.selectedDropdownValue = selectedValue[0].dial_code;
        },
    },
});
